import React, { useEffect, useState } from 'react';
import ShopifyBuyButton from './ShopifyBuyButton';
import { getShopifySettings } from '../lib/shopifyClient';

/**
 * BookBuyButton — payment-layer wrapper for books, mirrors TrackBuyButton.
 *
 * Renders a Shopify Buy Button product component for a book when the admin
 * has mapped that book to a Shopify product id. If not, returns null so the
 * caller can fall back to the legacy Stripe purchase button. Uses the shared
 * singleton Shopify UI so the cart icon stays in sync with track purchases.
 */
const bookButtonOptions = {
  product: {
    contents: { img: false, title: false, price: false, options: false, description: false, button: true },
    styles: {
      product: { 'max-width': '100%', 'margin': '0' },
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        'font-family': 'Outfit, sans-serif',
        'font-weight': '600',
        'letter-spacing': '0.05em',
        'text-transform': 'uppercase',
        'padding': '14px 18px',
        'width': '100%',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
    text: { button: 'Buy Book' },
  },
  modalProduct: {
    contents: { img: false, imgWithCarousel: true, button: false, buttonWithQuantity: true },
    styles: {
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
    text: { button: 'Add to cart' },
  },
  cart: {
    text: { total: 'Subtotal', button: 'Checkout' },
    styles: {
      button: {
        'background-color': '#D4AF37',
        color: '#000000',
        ':hover': { 'background-color': '#E5C048' },
        ':focus': { 'background-color': '#E5C048' },
      },
    },
  },
};

const BookBuyButton = ({ book }) => {
  const [shop, setShop] = useState(null);
  useEffect(() => {
    let alive = true;
    getShopifySettings().then((s) => {
      if (alive) setShop(s);
    });
    return () => { alive = false; };
  }, []);

  if (!book || !book.shopify_product_id) return null;
  if (shop === null) return null;
  if (!shop.domain || !shop.token) return null;

  return (
    <div
      className="w-full"
      onClick={(e) => e.stopPropagation()}
      data-testid={`book-buy-${book.id}`}
    >
      <ShopifyBuyButton
        shopDomain={shop.domain}
        storefrontToken={shop.token}
        componentType="product"
        componentId={book.shopify_product_id}
        options={bookButtonOptions}
      />
    </div>
  );
};

export default BookBuyButton;
